export const _checkNoProcessingTask = (self) => {
  if (self._processing_task != null) {
    throw new Error(
      `진행중인 작업이 있습니다. 먼저 완료해주세요. : ${self._processing_task.toString()}`
    );
  }
};
